(function () {
  if (window.__alphaCartAddonsBound) return;
  window.__alphaCartAddonsBound = true;

  var CART_UPDATE_EVENT = 'cart:update';

  function getSectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (component) {
      var sectionId = component.getAttribute('data-section-id');
      if (sectionId && ids.indexOf(sectionId) === -1) ids.push(sectionId);
    });
    return ids;
  }

  function buildSectionsPayload(extra) {
    var payload = extra || {};
    var ids = getSectionIds();
    if (ids.length) {
      payload.sections = ids.join(',');
      payload.sections_url = window.location.pathname;
    }
    return payload;
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (response) {
      if (!response.ok) throw new Error('Unable to fetch cart');
      return response.json();
    });
  }

  function dispatchCartUpdate(resource, cart) {
    var sections = resource && resource.sections ? resource.sections : {};
    var itemCount = cart && typeof cart.item_count === 'number'
      ? cart.item_count
      : (resource && typeof resource.item_count === 'number' ? resource.item_count : 0);

    document.dispatchEvent(new CustomEvent(CART_UPDATE_EVENT, {
      bubbles: true,
      detail: {
        resource: resource,
        sourceId: 'alpha-cart-addons',
        data: {
          itemCount: itemCount,
          source: 'alpha-cart-addons',
          sections: sections
        }
      }
    }));
  }

  function setBusy(row, busy) {
    row.classList.toggle('is-busy', busy);
    var input = row.querySelector('input[type="checkbox"]');
    if (input) input.disabled = busy;
  }

  function addAddon(row) {
    var variantId = parseInt(row.getAttribute('data-variant-id'), 10);
    if (!variantId) return Promise.reject(new Error('Missing add-on variant'));

    var payload = buildSectionsPayload({
      items: [
        {
          id: variantId,
          quantity: 1,
          properties: { _cart_addon: 'true' }
        }
      ]
    });

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Alpha-Cart-Addon': 'true'
      },
      body: JSON.stringify(payload)
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to add cart add-on');
      return response.json();
    });
  }

  function removeAddon(row) {
    var lineKey = row.getAttribute('data-line-key');
    var variantId = parseInt(row.getAttribute('data-variant-id'), 10);
    var id = lineKey || variantId;
    if (!id) return Promise.reject(new Error('Missing add-on line'));

    return fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Alpha-Cart-Addon': 'true'
      },
      body: JSON.stringify(buildSectionsPayload({ id: id, quantity: 0 }))
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to remove cart add-on');
      return response.json();
    });
  }

  function handleAddonChange(event) {
    var input = event.target;
    if (!(input instanceof HTMLInputElement)) return;

    var row = input.closest('[data-alpha-cart-addon]');
    if (!row) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (row.classList.contains('is-busy')) return;

    setBusy(row, true);
    (input.checked ? addAddon(row) : removeAddon(row))
      .then(function (resource) {
        return fetchCart().then(function (cart) {
          dispatchCartUpdate(resource, cart);
        });
      })
      .catch(function () {
        input.checked = !input.checked;
      })
      .finally(function () {
        setBusy(row, false);
      });
  }

  document.addEventListener('change', handleAddonChange, true);
})();
